import React, { useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import $ from "jquery";
import { useState } from 'react';
import { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import PreLoginApi from '../../../components/Api/PreLoginApi';
import { COMPANY_BANNER_IMAGE_D_RATION, COMPANY_BANNER_IMAGE_H, COMPANY_BANNER_IMAGE_W, MAX_UPLOAD_FILE_SIZE } from '../../../components/Constants/FileUpload';
import FooterContact from '../FooterContact';


const StepThree = () => {
    let navigate = useNavigate();
    const [data, setData] = useState({});


    // Logo
    const fileInput = useRef();
    const [file, setFile] = useState();

    const selectFile = () => {
        fileInput.current.click();
    }

    const uploadLogo = (e) => {
        if( !e.target?.files[0] ) {
            return;
        }
        
        if(e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }

        if (!e.target.files[0]["type"].includes("image/")) {
            toast.error("Please upload valid Image file.");
            return;
        }

        setFile(e.target.files[0]);
    }
    // Logo End

    // Banner
    const fileInput2 = useRef();
    const [file2, setFile2] = useState();

    const selectFile2 = () => {
        fileInput2.current.click();
    }

    const uploadBanner = (e) => {
        if( !e.target?.files[0] ) {
            return;
        }
        
        if(e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }

        if (!e.target.files[0]["type"].includes("image/")) {
            toast.error("Please upload valid Image file.");
            return;
        }


        let img = new Image();
        img.src = window.URL.createObjectURL(e.target.files[0]);
        img.onload = async () => {
            let w = img.width, h = img.height;

            if( w < COMPANY_BANNER_IMAGE_W || h < COMPANY_BANNER_IMAGE_H ) {
                toast.error("Please upload company banner with proper dimension : " + COMPANY_BANNER_IMAGE_W + " x " + COMPANY_BANNER_IMAGE_H);
            }
            else {
                let r = parseFloat(w/h).toFixed(2);
                if( r !== COMPANY_BANNER_IMAGE_D_RATION ) {
                    toast.error("Please upload company banner with valid ratio (w/h) : " + parseInt(COMPANY_BANNER_IMAGE_D_RATION));
                }
                else {
                    setFile2(e.target.files[0]);
                }
            }
        };
    }
    // Banner End


    // Trade License
    const fileInput3 = useRef();
    const [file3, setFile3] = useState();

    const selectFile3 = () => {
        fileInput3.current.click();
    }

    const uploadTL = (e) => {
        if( !e.target?.files[0] ) {
            return;
        }
        
        if(e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }

        if (!e.target.files[0]["type"].includes("image/") && e.target.files[0]["type"] !== "application/pdf") {
            toast.error("Please upload valid Image file.");
            return;
        }

        setFile3(e.target.files[0]);
    }
    // Trade License End




    const [input, setInput] = useState({});
    useEffect(()=>{
        const tokenParam = new URLSearchParams(window.location.search).get('token')?.toString().replaceAll(" ","+");
        if( tokenParam === null || tokenParam === undefined || tokenParam === "" ) {
            return navigate("/");
        }

        // Now Check by API call
        try {
            PreLoginApi("panel/company-registration-request/validateToken",JSON.stringify({token: tokenParam})).then((responseJSON) => {
                
                var response = JSON.stringify(responseJSON);
                response = JSON.parse(response);

                if( response["status"] === 0 ) {
                    toast.error("A problem occur. Please try again.");
                    return navigate("/");
                }
                
                let data = JSON.stringify(response["data"]);
                data = JSON.parse(data);

                if (data["code"] === 200) {
                    setData(data["data"]);


                    const step2 = JSON.parse(data["data"]?.step2);
                    if( step2?.address?.length > 0 ) {
                        return navigate("/company-registration-step-four?token="+tokenParam);
                    }

                    setInput({...input, token: tokenParam});
                    return;
                }


                // redirect to login page
                toast.error(data["messages"]);
                return navigate("/company-registration-step-two?token="+tokenParam);

                
            }).catch((error) => {
                toast.error(error);
            });
        }
        catch (err) {
            toast.error(err);
            console.log(err);
        }

    },[]);


    const handleSubmit = event => {
        event.preventDefault();

        if(input.service_type === undefined || input.service_type === null) {
            toast.error("Please choose at least one service type.");
            return;
        }

        if(input.service_type?.length === 0) {
            toast.error("Please choose at least one service type.");
            return;
        }

        if( file === undefined || file2 === undefined || file3 === undefined ) {
            toast.error("Please upload all 3 documents.");
            return;
        }

        // Now call API to store and proceed to next
        let requestBody = new FormData();
        requestBody.append("token",data.token);
        requestBody.append("email_address",data.email_address);
        requestBody.append("address", input.address);
        requestBody.append("current_address", input.current_address ?? input.address);
        requestBody.append("service_type", input.service_type);
        requestBody.append("logo", file);
        requestBody.append("banner", file2);
        requestBody.append("trade_license", file3);



        PreLoginApi("panel/company-registration-request/step2", requestBody, 1).then((responseJSON) => {
            var response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if( response["status"] === 0 ) {
                toast.error("A problem occur. Please try again.");
                return;
            }
            
            let responseData = JSON.stringify(response["data"]);
            responseData = JSON.parse(responseData);

            if (responseData["code"] === 200) {
                toast.success(responseData["messages"] ?? "Information added successfully");
                return navigate("/company-registration-step-four?token=" + data.token);
            }

            toast.error(responseData["messages"]);
        }).catch((error) => {
            toast.error("A problem occur. Please try again.");
            console.log(error);
        });
    }


    const handleChange = (event) => {
        const name = event.target.name;
        let value = event.target.value;

        setInput({...input, [name] : value});
    }


    useEffect(()=>{
        $('.btn').css({ opacity: '0.6' });
        $('.btn').attr("disabled", true);
        
        if(input.address?.length > 0) {

            if( $("#link-checkbox").prop("checked") === true ) {
                if(input.current_address?.length === 0) {
                    return;
                }
            }

            if( file === undefined || file2 === undefined || file3 === undefined ) {
                return;
            }

            if(input.service_type === undefined || input.service_type === null) {
                return;
            }

            if(input.service_type?.length === 0) {
                return;
            }


            $('.btn').css({ opacity: '1' });
            $('.btn').attr("disabled", false);
        }

    },[input, file, file2, file3]);


    const addressCheck = () => {
        $("#current_address").attr("required",false);
        setInput({...input, current_address: input.address});
        $("#current_address_div").addClass("hidden");
        if( $("#link-checkbox").prop("checked") === true ) {
            $("#current_address_div").removeClass("hidden");
            $("input[name='current_address']").focus();
            $("#current_address").attr("required",true);
            setInput({...input, current_address: ""});
        }
    }


    const serviceType = () => {
        let arr = [];
        if($("#service_type").prop("checked")===true) {
            arr.push("shop");
        }

        if($("#service_type2").prop("checked")===true) {
            arr.push("voucher");
        }

        setInput({...input, service_type: arr});
    }

    return (
        <section className="h-screen bg-white font-murecho">
            <ToastContainer />
            <div className="h-full justify-center">
                {/* <!-- Left column container with background--> */}


                <div className="flex h-full flex-wrap items-center justify-center lg:justify-center">


                    {/* <!-- Right column container --> */}
                    <div className="mb-12 md:mb-0 md:w-8/12 lg:w-5/12 xl:w-5/12">

                        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">

                            <div className="w-full bg-[#1882FF] rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0">
                                <div className="p-6 sm:p-10">

                                    <p className='text-white text-xl'>Welcome to</p>

                                    <p className="mb-6 font-semibold leading-8 text-white text-[25px] dark:text-white">
                                        ShareTrip Partner Registration
                                    </p>


                                    
                                    <form onSubmit={handleSubmit} method="POST">
                            

                                        <p className='text-white font-medium text-sm mb-0.5 ml-1'>Account Name (Same as company name)</p>
                                        <div className='mb-2'>
                                            <input type="text" name="account_name" autoComplete='off' disabled={true} value={data.company_name ?? ""} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed" placeholder="Account Name (Same as company name)" required={true} />
                                        </div>

                                        <p className='text-white font-medium text-sm mb-0.5'>Company Address (As per Trade License) *</p>
                                        <div className='mb-2'>
                                            <input type="text" name="address" autoComplete='off' value={input.address ?? ""} onChange={handleChange} className="bg-white border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed" placeholder="Company Address (As per Trade License)" required={true} />
                                        </div>


                                        <div className="flex items-center mt-2 mb-4">
                                            <input id="link-checkbox"  value={1} onClick={addressCheck} type="checkbox" 
                                            className="w-4 h-4 text-black bg-white border-gray-300 rounded cursor-pointer outline-none" />
                                            <label htmlFor="link-checkbox" className="ms-2 text-sm font-medium text-white  cursor-pointer">
                                                Current address is different from trade license.
                                            </label>
                                        </div>

                                        <span id="current_address_div" className='hidden'>
                                            <p className='text-white font-medium text-sm mb-0.5'>Company Current Address</p>
                                            <div className='mb-2'>
                                                <input type="text" name="current_address" autoComplete='off' value={input.current_address ?? ""} onChange={handleChange} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed" placeholder="Company Current Address" />
                                            </div>
                                        </span>


                                        <p className='text-white font-medium text-sm mt-3 mb-1'>Choose Service Type *</p>
                                        <div className="flex items-center mt-2 mb-4">    
                                            <input id="service_type" value={"shop"} onClick={serviceType} type="checkbox" 
                                            className="w-4 h-4 text-black bg-gray-100 border-gray-300 rounded cursor-pointer outline-none" />
                                            <label htmlFor="service_type" className="ms-2 text-sm font-medium text-white  cursor-pointer">
                                                Shop
                                            </label>

                                            <input id="service_type2" value={"voucher"} onClick={serviceType} type="checkbox" 
                                            className="ml-5 w-4 h-4 text-black bg-gray-100 border-gray-300 rounded cursor-pointer outline-none" />
                                            <label htmlFor="service_type2" className="ms-2 text-sm font-medium text-white  cursor-pointer">
                                                Voucher
                                            </label>
                                        </div>
                                        


                                        <div className='flex text-white font-medium text-sm mb-1 mt-5 py-[6px] rounded-md pr-1' style={{border: "2px dotted #F0F0F0"}}>
                                            <input type="file" className="hidden" name="logo" ref={fileInput} onChange={uploadLogo} />
                                            <label htmlFor="logo" className="p-1 text-inherit">Company Logo *</label>
                                            {file ?
                                                <>
                                                    { file["type"].includes("image/") && 
                                                    <img src={URL.createObjectURL(file)} alt="Preview Logo" className="max-h-8 max-w-6 ml-auto order-3" /> }

                                                    <button type="button" className="text-white ml-auto order-3 bg-[#444] py-[5px] px-[10px] rounded-[3px] cursor-pointer block justify text-xs" onClick={selectFile}>Change</button>
                                                </> :
                                                <>
                                                    <button type="button" className="text-white ml-auto order-3 bg-[#444] py-[5px] px-[20px] rounded-[3px] cursor-pointer block justify text-xs" onClick={selectFile}>Upload</button>
                                                </>
                                            }
                                        </div>


                                        <div className='flex text-white font-medium text-sm mb-2 mt-4 py-[6px] rounded-md pr-1' style={{border: "2px dotted #F0F0F0"}}>
                                            <input type="file" className="hidden" name="logo" ref={fileInput2} onChange={uploadBanner} />
                                            <label htmlFor="logo" className="p-1 text-inherit">Company Banner *</label>
                                            {file2 ?
                                                <>
                                                    { file2["type"].includes("image/") && 
                                                    <img src={URL.createObjectURL(file2)} alt="Preview Logo" className="max-h-8 max-w-6 ml-auto order-3" /> }

                                                    <button type="button" className="text-white ml-auto order-3 bg-[#444] py-[5px] px-[10px] rounded-[3px] cursor-pointer block justify text-xs" onClick={selectFile2}>Change</button>
                                                </> :
                                                <>
                                                    <button type="button" className="text-white ml-auto order-3 bg-[#444] py-[5px] px-[20px] rounded-[3px] cursor-pointer block justify text-xs" onClick={selectFile2}>Upload</button>
                                                </>
                                            }
                                        </div>

                                        <div className='flex text-white font-medium text-sm mb-2 mt-4 py-[6px] rounded-md pr-1' style={{border: "2px dotted #F0F0F0"}}>
                                            <input type="file" className="hidden" name="logo" ref={fileInput3} onChange={uploadTL} />
                                            <label htmlFor="logo" className="p-1 text-inherit">Company Trade License *</label>
                                            {file3 ?
                                                <>
                                                    { file3["type"].includes("image/") ?
                                                    <img src={URL.createObjectURL(file3)} alt="Preview Trade License" className="max-h-8 max-w-6 ml-auto order-3" /> 
                                                    :
                                                    <span className='text-xs w-[110px] pt-[6px] overflow-hidden whitespace-nowrap overflow-ellipsis' title={file3["name"]}>
                                                        {file3["name"]}
                                                    </span>
                                                    }

                                                    <button type="button" className="text-white ml-auto order-3 bg-[#444] py-[5px] px-[10px] rounded-[3px] cursor-pointer block justify text-xs" onClick={selectFile3}>Change</button>
                                                </> :
                                                <>
                                                    <button type="button" className="text-white ml-auto order-3 bg-[#444] py-[5px] px-[20px] rounded-[3px] cursor-pointer block justify text-xs" onClick={selectFile3}>Upload</button>
                                                </>
                                            }
                                        </div>

                                        
                                        <button id="submit_btn" disabled={true} className="btn mt-4 w-full mb-3 text-white bg-[#003897] hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg px-6 py-3 text-center opacity-60 disabled:cursor-not-allowed">
                                            Next
                                        </button>


                                        {/* <p className='text-white text-sm text-right mr-1'>
                                            <span onClick={cancelProceed} className="cursor-pointer text-sm font-medium text-white text-right ml-1">
                                                Register Later ?
                                            </span>
                                        </p> */}

                                    </form>
                                    
                                </div>
                            </div>

                            <FooterContact />
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default StepThree;